import { FfNgxStorageBundleConfig } from '@fagforbundet/ngx-components';

export const storageBundleConfig: FfNgxStorageBundleConfig = {
  debug: false,
};
